import Link from "next/link";
import { ChevronLeft } from "lucide-react";
import ImageComponent from "@core/helpers/client/components/image";
import { alt_unless_repeated } from "@/helpers/imageAlt";


const AcademyCardHorizontal = ({ blog, storage_prefix_url }) => {
    const href = blog?.seo?.full_url || "#";

    return (
        <Link
            href={href}
            className="hover-shadow-full-light flex h-full items-stretch overflow-hidden rounded-md border border-jmt-neutral-200 bg-jmt-white">

            <div className="w-24 aspect-square shrink-0 overflow-hidden bg-jmt-neutral-100 md:w-[134px]">
                <ImageComponent
                    storage_prefix_url={storage_prefix_url}
                    src={blog?.media?.url || ""}
                    alt={alt_unless_repeated(blog?.media?.alt || blog?.title, blog?.title)}
                    width={104}
                    height={104}
                    style={{ width: "100%", height: "100%" }}
                    image_className="w-full h-full object-cover"
                />
            </div>

            <div className="flex min-w-0 flex-1 flex-col gap-2 p-3">
                <h3 className="line-clamp-2 text-sm font-bold text-jmt-main">
                    {blog?.title}
                </h3>

                {blog?.summary && (
                    <p className="line-clamp-3 text-xs text-jmt-neutral-600">
                        {blog?.summary}
                    </p>
                )}

                <span className="mt-auto flex items-center gap-1 pt-2 text-xs font-bold text-jmt-primary-800">
                    بیشتر بخوانید
                    <ChevronLeft size={16} />
                </span>
            </div>

        </Link>
    );
};

export default AcademyCardHorizontal;
